import { RESET_STORE } from "../actions/resetStoreAction";
import { SET_USER_DETAILS, SET_ACCESSIBLE_APPLICATIONS, SET_SURVEY_STATS } from "../actions/landingPageAction";

const initialState = {
  userDetails: null,
  accessibleApplications: [],
  surveyStats: null,
};

export const landingPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
      };

    case SET_ACCESSIBLE_APPLICATIONS:
      return {
        ...state,
        accessibleApplications: action.payload,
      };

    case SET_SURVEY_STATS:
      return {
        ...state,
        surveyStats: action.payload,
      };

    case RESET_STORE:
      return {
        ...initialState,
        userDetails: action.retainUserDetails ? state.userDetails : initialState.userDetails,
      };

    default:
      return state;
  }
};
